module.exports = __webpack_public_path__ + "assets/media/day3.6f8cef2c.mp3";